module.exports = __webpack_public_path__ + "img/gallery-pic06.83e02ee2.jpg";